import {
    Box,
    Button,
    Grid, InputAdornment, TextField
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { GoogleLogin } from "@react-oauth/google";
import React, { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
    IsNullOrEmpty,
    uuidv4,
    validEmail,
    validPassword,
    validPhone,
    validUsername
} from "../../helpers/utility";
import {
    loginGoogleRequest,
    preSignUpEmailRequest,
    preSignUpPhoneRequest,
    resetUserState
} from "../../store/user/user.actions";
import {
    getAccessToken,
    getisLoading,
    getPreSignupEmail,
    getPreSignupPhone
} from "../../store/user/user.selector";
import Authentication from "./authentication";

function SignUp() {
    const location = useLocation();
    const [type, setType] = useState("email");
    const [visible, setVisible] = useState(false);
    const [showOTP, setShowOTP] = useState(false);
    const [phone, setPhone] = useState("");
    const [countryCode, setCountry] = useState("+60");
    const [email, setEmail] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [selected, setSelected] = useState("MY");
    const [usererrMsg, setuserErrMsg] = useState("");
    const [pswerrMsg, setpswErrMsg] = useState("");
    const [error, setError] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const dispatch = useDispatch();
    const history = useNavigate();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const { preSignupPhone, accessToken, isLoading, preSignupEmail } =
        useSelector((state) => {
            return {
                preSignupPhone: getPreSignupPhone(state),
                preSignupEmail: getPreSignupEmail(state),
                isLoading: getisLoading(state),
                accessToken: getAccessToken(state),
            };
        });

    useEffect(() => {
        if (location && location.state && location.state.userName) {
            setUserName(location.state.userName);
        }
    }, [location]);

    useEffect(() => {
        let token = sessionStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);
        if (!IsNullOrEmpty(token)) {
            history("/");
        }
    }, [accessToken]);

    useEffect(() => {
        if (
            (!preSignupPhone.isAllowSignup && !preSignupPhone.isSentOtp) ||
            (!preSignupEmail.isAllowSignup && !preSignupEmail.isSentOtp)
        ) {
            dispatch(resetUserState());
        }
        setShowOTP(false);
    }, []);

    useEffect(() => {
        if (!IsNullOrEmpty(accessToken)) {
            history("/");
        }
    }, [accessToken]);

    useEffect(() => {
        if (preSignupPhone.isAllowSignup && preSignupPhone.isSentOtp) {
            setShowOTP(true);
        }
    }, [preSignupPhone]);

    useEffect(() => {
        if (preSignupEmail.isAllowSignup && preSignupEmail.isSentOtp) {
            setShowOTP(true);
        }
    }, [preSignupEmail]);

    const handleSignUp = () => {
        if (validate()) {
            let isValidPassword = validPassword(password);
            let isValidUsername = validUsername(userName);

            // if (!isValidUsername) {
            //     setError(true);
            //     setuserErrMsg(
            //         "Username must be between 6 - 30 characters and alpha numerical only."
            //     );
            //     //return toastr.error("Username must be between 6 - 30 characters and alpha numerical only.");
            // } else {
            //     setError(false);
            //     setuserErrMsg("");
            // }
            if (!isValidPassword) {
                setError(true);
                setpswErrMsg(
                    "Password must be at least 8 character long, contain at least one uppercase letter, one number and one special character."
                );
                //return toastr.error("Password must be at least 8 character long, contain at least one uppercase letter, one number and one special character.");
            } else {
                setError(false);
                setpswErrMsg("");
            }
            if (isValidPassword) {
                if (type === "phone") {
                    dispatch(
                        preSignUpPhoneRequest({
                            phone: countryCode + phone,
                        })
                    );
                } else {
                    dispatch(
                        preSignUpEmailRequest({
                            email: email,
                        })
                    );
                }
            }
        } else {
            setFormSubmitted(true);
        }
    };

    const validate = () => {
        if (type === "phone") {
            return (
                !IsNullOrEmpty(phone) &&
                validPhone(phone) &&
                !IsNullOrEmpty(password) &&
                !IsNullOrEmpty(countryCode)
            );
        }
        if (type === "email") {
            return (
                !IsNullOrEmpty(email) &&
                validEmail(email) &&
                !IsNullOrEmpty(password)
            );
        }
    };

    const handleSelect = (code) => {
        setSelected(code);
        if (code === "SG") setCountry("+65");
        if (code === "MY") setCountry("+60");
        if (code === "US") setCountry("+1");
    };

    function getCountryName(str) {
        if (str === "+65") {
            return "SG";
        } else if (str === "+60") {
            return "MY";
        } else {
            return "US";
        }
    }

    if (
        showOTP &&
        !IsNullOrEmpty(password) &&
        ((type === "phone" &&
            preSignupPhone.isAllowSignup &&
            preSignupPhone.isSentOtp) ||
            (type === "email" &&
                preSignupEmail.isAllowSignup &&
                preSignupEmail.isSentOtp))
    ) {
        return (
            <Authentication
                type={type}
                onClose={() => setShowOTP(false)}
                data={
                    type === "phone"
                        ? {
                            phone: countryCode + phone,
                            userName: userName,
                            password: password,
                            countryCode: countryCode.replace("+", ""),
                            originalCountry: getCountryName(countryCode),
                            deviceId: uuidv4(),
                            deviceType: "android",
                        }
                        : {
                            account: email,
                            userName: userName,
                            password: password,
                            countryCode: countryCode.replace("+", ""),
                            originalCountry: getCountryName(countryCode),
                            deviceId: uuidv4(),
                            deviceType: "android",
                        }
                }
            />
        );
    }

    const loginTwitter = () => {
        document.location.href =
            "https://ulalive.io/auth/twitter/authenticate";
    };

    return (
        <html data-wf-domain="ulalive.webflow.io" data-wf-page="63f58007bbc14aa4a5d30ed6"
            data-wf-site="63de900d6cd30521137c4171">
            <head>
                <meta charset="utf-8" />
                <title>Login</title>
                <meta content="Sign up for free. No credit card required." name="description" />
                <meta content="Login" property="og:title" />
                <meta content="Sign up for free. No credit card required." property="og:description" />
                <meta
                    content="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63f1e6b063ea2225383348ae_Personalised%20for%20your%20video.png"
                    property="og:image" />
                <meta content="Login" property="twitter:title" />
                <meta content="Sign up for free. No credit card required." property="twitter:description" />
                <meta
                    content="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63f1e6b063ea2225383348ae_Personalised%20for%20your%20video.png"
                    property="twitter:image" />
                <meta property="og:type" content="website" />
                <meta content="summary_large_image" name="twitter:card" />
                <meta content="width=device-width, initial-scale=1" name="viewport" />
                <link href="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/css/ulalive.webflow.7270debcd.css"
                    rel="stylesheet" type="text/css" />
                <link href="https://fonts.googleapis.com" rel="preconnect" />
                <link href="https://fonts.gstatic.com" rel="preconnect" crossorigin="anonymous" />
                <script src="https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js" type="text/javascript"></script>
                <link href="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63f1cc8b461fa02877c64e5b_favicon-32x32.png"
                    rel="shortcut icon" type="image/x-icon" />
                <link href="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63f1ccc1466e62361f597c04_Shared%20image.png"
                    rel="apple-touch-icon" />
                <script async="" src="https://www.googletagmanager.com/gtag/js?id=G-E35D7WJ32R"></script>
                <script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async></script>
                <script src="https://apis.google.com/js/platform.js" async defer></script>
            </head>
            <body>
                <div class="global">
                    <div class="html w-embed">
                    </div>
                </div>
                <div class="page-overlay">
                    <div class="overlay-transition"></div>
                    <div class="logo-loader-wrapper"><img
                        src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black.png"
                        loading="lazy" sizes="100vw"
                        srcset="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black-p-500.png 500w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black-p-800.png 800w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black-p-1080.png 1080w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black.png 1235w"
                        alt="" class="logo-loader" />
                    </div>
                </div>
                <div data-animation="default" data-collapse="medium" data-duration="800" data-easing="ease" data-easing2="ease"
                    data-doc-height="1" role="banner" class="navigation w-nav">
                    <div class="div-block-110">
                        <div>We are launching on Product Hunt soon!</div>
                        <img
                            src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e7c3905b939f0d9b8b73d4_ProductHunt.5137546a2234ca8ccd3f1c4deb15eb12.svg"
                            loading="lazy" alt="" class="image-55" />
                    </div>
                    <div class="container nav">
                        <div class="nav-grid">
                            <div class="brand-logo-wrapper"><a href="https://ulalive.com" class="nav-brand w-nav-brand"><img
                                src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202.png"
                                loading="lazy" sizes="(max-width: 991px) 126px, 112px"
                                srcset="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202-p-500.png 500w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202-p-800.png 800w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202-p-1080.png 1080w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202-p-1600.png 1600w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202-p-2000.png 2000w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202-p-2600.png 2600w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202-p-3200.png 3200w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66e449ce71a48cd27834b_Assets%20logo_Logo%20Ulalive%202.png 4500w"
                                alt="" /></a></div>
                            <nav role="navigation" class="menu-nav w-nav-menu">
                                <div class="menu-nav-link-wrapper">
                                    <div class="nav-link-wrapper"><a href="https://ulalive.com/pricing" class="nav-link w-nav-link">Pricing</a></div>
                                    <div class="nav-link-wrapper"><a href="https://ulalive.com/about" class="nav-link w-nav-link">About</a></div>
                                    <div class="nav-link-wrapper"><a href="https://ulalive.com/faq" class="nav-link w-nav-link">FAQ</a></div>
                                    <div class="nav-link-wrapper"><a href="https://ulalive.com/blog" class="nav-link w-nav-link">Blog</a></div>
                                    <div class="nav-link-wrapper"><a href="https://ulalive.typeform.com/requestdemo" target="_blank"
                                        class="nav-link w-nav-link">Request Demo</a></div>
                                    <div class="nav-link-wrapper last mobile">
                                        <a href="https://revolutio.webflow.io/"
                                            target="_blank" class="button small w-inline-block">
                                            <div class="button-text-wrapper">
                                                <div class="button-text">Sign up</div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="nav-link-wrapper last mobile">
                                        <a href="#"
                                            class="button small orange w-inline-block">
                                            <div class="button-text-wrapper">
                                                <div class="button-text">Try for free</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </nav>
                            <div class="nav-link-wrapper last">
                                <a href="/login" aria-current="page"
                                    class="button small w-inline-block w--current">
                                    <div class="button-text-wrapper">
                                        <div class="button-text">Login</div>
                                    </div>
                                </a>
                                <a href="/signup" target="_blank" class="button small orange w-inline-block">
                                    <div class="button-text-wrapper">
                                        <div class="button-text">Try for free</div>
                                    </div>
                                </a>
                            </div>
                            <div class="menu-button w-nav-button">
                                <div class="hamburger-icon">
                                    <div class="hamburger-bar _1"></div>
                                    <div class="hamburger-bar _2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-wrapper">
                    <div class="section hero login wf-section">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <div class="login-wrapper sign-up">
                                    <div class="form-block w-form">
                                        <form onSubmit={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleSignUp()
                                        }}>
                                            <div class="center-wrapper">
                                                <div class="max-width">
                                                    <h2>Sign up</h2>
                                                </div>
                                                <div class="spacer _20"></div>
                                            </div>
                                            <a id="customBtn" class="button google">
                                                <GoogleLogin
                                                    onSuccess={credentialResponse => {
                                                        dispatch(loginGoogleRequest({
                                                            accessToken: credentialResponse.credential,
                                                            countryCode: "60",
                                                            originalCountry: "MY",
                                                            deviceId: "A6FFFEBE-8282-484D-BE5B-2439013F44B1",
                                                            deviceType: "android",
                                                            deviceToken: "d2dfe7d1-21b7-4dd4-b16c-00774e2ea815",
                                                        }))
                                                    }}
                                                    onError={() => {
                                                        console.log('Login Failed');
                                                    }}
                                                />
                                            </a>
                                            <div class="or-wrap">
                                                <div class="or-line"></div>
                                                <p class="paragraph-3">or</p>
                                                <div class="or-line"></div>
                                            </div>
                                            {/* <Paper square className="mt-3">
                                            <Tabs
                                                variant="fullWidth"
                                                value={value}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                onChange={handleChange}
                                                aria-label="disabled tabs example"
                                            >
                                                <Tab
                                                    fullWidth
                                                    label="Email"
                                                    onClick={() => setType("email")}
                                                />
                                                <Tab
                                                    fullWidth
                                                    label="Phone"
                                                    onClick={() => setType("phone")}
                                                />
                                            </Tabs>
                                        </Paper> */}
                                            {!IsNullOrEmpty(usererrMsg) ? (
                                                <Box textAlign="center" className="mt-4">
                                                    <Alert severity="error">{usererrMsg}</Alert>
                                                </Box>
                                            ) : (
                                                <></>
                                            )}
                                            {!IsNullOrEmpty(pswerrMsg) ? (
                                                <Box textAlign="center" className="mt-4">
                                                    <Alert severity="error">{pswerrMsg}</Alert>
                                                </Box>
                                            ) : (
                                                <></>
                                            )}
                                            <Grid
                                                container
                                                spacing={2}
                                                maxWidth={false}
                                                className="mt-4"
                                            >
                                                <Grid item sm={12} xs={12}>
                                                    {type === "email" ? (
                                                        <TextField
                                                            variant="outlined"
                                                            fullWidth
                                                            className="bg-white"
                                                            helperText={
                                                                formSubmitted &&
                                                                    (IsNullOrEmpty(email) ||
                                                                        !validEmail(email))
                                                                    ? "Email Should be valid and not empty"
                                                                    : ""
                                                            }
                                                            error={
                                                                formSubmitted &&
                                                                (IsNullOrEmpty(email) ||
                                                                    !validEmail(email))
                                                            }
                                                            label="Email"
                                                            placeholder="Email"
                                                            value={email}
                                                            onChange={(e) => {
                                                                setEmail(e.target.value);
                                                            }}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            variant="outlined"
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <ReactFlagsSelect
                                                                            className="react-select"
                                                                            selected={selected}
                                                                            onSelect={(code) =>
                                                                                handleSelect(
                                                                                    code
                                                                                )
                                                                            }
                                                                            countries={[
                                                                                "MY",
                                                                                "SG",
                                                                                "US",
                                                                            ]}
                                                                            customLabels={{
                                                                                MY: "Malaysia +60",
                                                                                SG: "Singapore +65",
                                                                                US: "United States +1",
                                                                            }}
                                                                        />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            fullWidth
                                                            helperText={
                                                                formSubmitted &&
                                                                    (IsNullOrEmpty(phone) ||
                                                                        !validPhone(phone))
                                                                    ? "Phone Should be valid and not empty"
                                                                    : ""
                                                            }
                                                            error={
                                                                formSubmitted &&
                                                                (IsNullOrEmpty(phone) ||
                                                                    !validPhone(phone))
                                                            }
                                                            label="Mobile number"
                                                            placeholder="Mobile number"
                                                            value={phone}
                                                            onChange={(e) => {
                                                                setPhone(e.target.value);
                                                            }}
                                                        />
                                                    )}
                                                </Grid>

                                                {/* <Grid item sm={12} xs={12}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    helperText={
                                                        formSubmitted &&
                                                            IsNullOrEmpty(userName)
                                                            ? "Username Should be valid and not empty"
                                                            : ""
                                                    }
                                                    error={
                                                        formSubmitted &&
                                                        IsNullOrEmpty(userName)
                                                    }
                                                    label="Username"
                                                    placeholder="Username"
                                                    value={userName}
                                                    className="bg-white"
                                                    onChange={(e) => {
                                                        setUserName(e.target.value);
                                                    }}
                                                />
                                            </Grid> */}
                                                <Grid item sm={12} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        type={visible ? "text" : "password"}
                                                        fullWidth
                                                        label="Password"
                                                        placeholder="Password"
                                                        className="bg-white"
                                                        helperText={
                                                            formSubmitted &&
                                                                IsNullOrEmpty(password)
                                                                ? "Password Should be valid and not empty"
                                                                : ""
                                                        }
                                                        error={
                                                            formSubmitted &&
                                                            IsNullOrEmpty(password)
                                                        }
                                                        value={password}
                                                        onChange={(e) => {
                                                            setPassword(e.target.value);
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {visible ? (
                                                                        <Visibility
                                                                            onClick={() =>
                                                                                setVisible(
                                                                                    !visible
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <VisibilityOff
                                                                            onClick={() =>
                                                                                setVisible(
                                                                                    !visible
                                                                                )
                                                                            }
                                                                        />
                                                                    )}
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item sm={12} xs={12}>
                                                    <div class="mt-1">
                                                        <p class="mb-17">
                                                            <a href="/login" class="forgot-pass">Already have an account?</a>
                                                        </p>
                                                    </div>
                                                    <Button
                                                        color="secondary"
                                                        className="my-2 button w-inline-block"
                                                        fullWidth
                                                        variant="contained"
                                                        onClick={() => handleSignUp()}
                                                    >
                                                        {isLoading ? (
                                                            <span
                                                                className="spinner-border spinner-border-sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        ) : (
                                                            "Sign up"
                                                        )}
                                                    </Button>
                                                </Grid>
                                            </Grid>

                                        </form>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <div class="max-width _700">
                                    <img src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63fac0a91098aa01cb9c4119_Testimonial%20(1).png" loading="lazy" width="399" sizes="(max-width: 479px) 49vw, (max-width: 767px) 26vw, 39vw" srcset="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63fac0a91098aa01cb9c4119_Testimonial%20(1)-p-500.png 500w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63fac0a91098aa01cb9c4119_Testimonial%20(1)-p-800.png 800w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63fac0a91098aa01cb9c4119_Testimonial%20(1)-p-1080.png 1080w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63fac0a91098aa01cb9c4119_Testimonial%20(1).png 1501w" alt="" class="image-57" />
                                    <h3 class="heading-5">"Ulalive is the only tool you need to prospect leads and grow <br />your business"</h3><div class="spacer _20"></div><p class="paragraph medium"></p></div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div class="footer-wrapper">
                    <div id="Contacts" class="section dark wf-section">
                        <div class="container footer w-container">
                            <div id="w-node-_99f8c7a7-4642-e68f-0834-4a891e16ec8a-b8e98f75" class="footer-card limit">
                                <img
                                    src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black.png"
                                    loading="lazy" width="197" sizes="100vw"
                                    srcset="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black-p-500.png 500w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black-p-800.png 800w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black-p-1080.png 1080w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63de945c1ca2f5e7d00ffbb1_Ulalive%20logo%20in%20black.png 1235w"
                                    alt="" class="image-39" />
                                <p class="main-paragraph big">Ready to get started?</p>
                            </div>
                            <div class="w-layout-grid footer-grid">
                                <div class="footer-card">
                                    <div class="footer-title-2"><strong>Product</strong></div>
                                    <a href="/pricing"
                                        class="footer-link-2">Pricing</a><a href="#" class="footer-link-2">Why Us<br /></a>
                                </div>
                                <div class="footer-card">
                                    <div class="footer-title-2"><strong>Company</strong></div>
                                    <a href="/about"
                                        class="footer-link-2">About<br /></a><a href="https://newsroom.ulalive.com/"
                                            class="footer-link-2">Press</a><a href="#" class="footer-link-2">Career<br /></a><a href="#"
                                                class="footer-link-2">Contact Us</a>
                                </div>
                                <div class="footer-card">
                                    <div class="footer-title-2"><strong>Customer</strong></div>
                                    <a href="#"
                                        class="footer-link-2">Customer Stories<br /></a><a href="#"
                                            class="footer-link-2">Testimonials</a>
                                </div>
                                <div class="footer-card">
                                    <div class="footer-title-2"><strong>Resources</strong></div>
                                    <a href="/blog"
                                        class="footer-link-2">FAQs<br /></a><a href="/blog" class="footer-link-2">Blog<br /></a><a
                                            href="#" class="footer-link-2">Help &amp; Support</a><a
                                                href="https://drive.google.com/drive/folders/18h4iWx8PS1b06Jc5ezoft1NPT4KfUYkX?usp=share_link"
                                                class="footer-link-2">Brand Asset</a><a href="#" class="footer-link-2 hide">FAQ</a>
                                </div>
                                <div id="w-node-_279cede6-6488-f89c-e75e-70bf96ece492-b8e98f75" class="footer-card">
                                    <div class="footer-title-2">Contacts<br /></div>
                                    <a href="tel:+6018-2929737"
                                        class="footer-link-2">+6018-2929737<br /></a><a
                                            href="mailto:Sheesh@ulalive.com?subject=You&#x27;ve%20got%20mail!"
                                            class="footer-link-2">Sheesh@ulalive.com</a><a href="#" class="footer-link-2">Level 1 &amp;
                                                2, Tower 3, <br />Avenue 7 Horizon 2 Bangsar South City, <br />Bangsar South, <br />59200
                                        Kuala Lumpur, <br />Malaysia<br /></a>
                                </div>
                                <div id="w-node-_279cede6-6488-f89c-e75e-70bf96ece49e-b8e98f75" class="footer-card">
                                    <div class="footer-title-2"><strong>Follow us on our social</strong></div>
                                    <div class="social-icons-wrapper">
                                        <a href="https://twitter.com/" target="_blank"
                                            class="social-link w-inline-block">
                                            <div class="social-icon w-embed">
                                                <svg width="100%" height="100%"
                                                    viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.3334 4.91684C17.7204 5.1772 17.0535 5.36457 16.3664 5.43755C17.0797 5.02027 17.6139 4.36102 17.8687 3.58351C17.1993 3.9756 16.4661 4.25054 15.7015 4.39613C15.3819 4.05969 14.9954 3.79167 14.566 3.60877C14.1366 3.42587 13.6736 3.332 13.2058 3.33302C11.313 3.33302 9.79071 4.84386 9.79071 6.69791C9.79071 6.95826 9.82276 7.21862 9.87484 7.46911C7.04064 7.32315 4.5129 5.98982 2.83241 3.9484C2.52621 4.46342 2.36575 5.04983 2.36772 5.64662C2.36772 6.81428 2.97062 7.84386 3.88998 8.44938C3.34818 8.42837 2.81908 8.28173 2.34569 8.02138V8.0628C2.34569 9.6979 3.51943 11.0529 5.08374 11.3646C4.79003 11.4397 4.48788 11.4781 4.18441 11.479C3.96208 11.479 3.75177 11.4573 3.53946 11.4277C3.9721 12.761 5.23196 13.7295 6.73218 13.761C5.55845 14.6663 4.08827 15.1989 2.49191 15.1989C2.20548 15.1989 1.94109 15.189 1.66669 15.1575C3.18093 16.1141 4.97759 16.6663 6.91245 16.6663C13.1937 16.6663 16.6308 11.5421 16.6308 7.09436C16.6308 6.9484 16.6308 6.80244 16.6208 6.65649C17.2858 6.1772 17.8687 5.58351 18.3334 4.91684Z"
                                                        fill="currentColor" />
                                                </svg>
                                            </div>
                                        </a>
                                        <a href="https://twitter.com/" target="_blank" class="social-link w-inline-block"><img
                                            src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66a3ed28e4d8646464462_5ecec78673e4440004f09e77.png"
                                            loading="lazy" width="Auto" sizes="(max-width: 479px) 19px, 20px"
                                            srcset="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66a3ed28e4d8646464462_5ecec78673e4440004f09e77-p-500.png 500w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66a3ed28e4d8646464462_5ecec78673e4440004f09e77-p-800.png 800w, https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66a3ed28e4d8646464462_5ecec78673e4440004f09e77.png 1576w"
                                            alt="" class="image-48" /></a><a href="https://twitter.com/" target="_blank"
                                                class="social-link w-inline-block"><img
                                                src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/63e66a630a5f85488f1e0c38_48968.png"
                                                loading="lazy" width="Auto" alt="" class="image-48" /></a>
                                        <a
                                            href="https://www.facebook.com" target="_blank" class="social-link w-inline-block">
                                            <div class="social-icon w-embed">
                                                <svg width="100%" height="100%"
                                                    viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M7.96062 18.3337V10.5132H5.83331V7.69742H7.96062V5.29241C7.96062 3.40253 9.21723 1.66699 12.1127 1.66699C13.2851 1.66699 14.152 1.77624 14.152 1.77624L14.0836 4.40568C14.0836 4.40568 13.1996 4.39731 12.2348 4.39731C11.1906 4.39731 11.0234 4.86506 11.0234 5.64141V7.69742H14.1666L14.0299 10.5132H11.0234V18.3337H7.96062Z"
                                                        fill="currentColor" />
                                                </svg>
                                            </div>
                                        </a>
                                        <a href="https://www.linkedin.com" target="_blank" class="social-link w-inline-block">
                                            <div class="social-icon w-embed">
                                                <svg width="100%" height="100%"
                                                    viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M17.6667 1.66699H2.33335C1.9646 1.66699 1.66669 1.96491 1.66669 2.33366V17.667C1.66669 18.0357 1.9646 18.3337 2.33335 18.3337H17.6667C18.0354 18.3337 18.3334 18.0357 18.3334 17.667V2.33366C18.3334 1.96491 18.0354 1.66699 17.6667 1.66699ZM6.61044 15.8691H4.13752V7.91491H6.61044V15.8691ZM5.37502 6.82741C5.09153 6.82741 4.81441 6.74334 4.5787 6.58585C4.34299 6.42835 4.15928 6.2045 4.05079 5.94259C3.94231 5.68068 3.91392 5.39249 3.96923 5.11445C4.02453 4.83641 4.16105 4.58101 4.3615 4.38056C4.56196 4.1801 4.81735 4.04359 5.09539 3.98828C5.37343 3.93298 5.66163 3.96136 5.92353 4.06985C6.18544 4.17833 6.4093 4.36205 6.56679 4.59776C6.72429 4.83347 6.80835 5.11059 6.80835 5.39408C6.80627 6.18574 6.1646 6.82741 5.37502 6.82741ZM15.8688 15.8691H13.3979V12.0003C13.3979 11.0774 13.3813 9.89199 12.1125 9.89199C10.8271 9.89199 10.6292 10.8962 10.6292 11.9337V15.8691H8.16044V7.91491H10.5313V9.00241H10.5646C10.8938 8.37741 11.7 7.71699 12.9042 7.71699C15.4084 7.71699 15.8688 9.36491 15.8688 11.5066V15.8691V15.8691Z"
                                                        fill="currentColor" />
                                                </svg>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="div-block-109">
                                <div class="div-block-113">
                                    <p class="main-paragraph"><a href="/terms-of-use">Terms</a></p>
                                    <p class="main-paragraph"><a href="/terms-of-use">Privacy</a></p>
                                </div>
                                <p class="main-paragraph">© 2023 Ulalive. All rights reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <script src="https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=63de900d6cd30521137c4171"
                    type="text/javascript" integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0="
                    crossorigin="anonymous"></script>
                <script src="https://uploads-ssl.webflow.com/63de900d6cd30521137c4171/js/webflow.fc24275cd.js"
                    type="text/javascript"></script>
            </body>
        </html >
        // <>
        //     <MainHeader />
        //     <div className="formContainer">
        //         <div className="container">
        //             <div className="row formRow">
        //                 <div className="col-lg-5">
        //                     <h1 className="formHeading">Create an account</h1>
        //                     <p className="formText">
        //                         It's free. No credit card required.
        //                     </p>

        //                     <Paper square className="mt-3">
        //                         <Tabs
        //                             variant="fullWidth"
        //                             value={value}
        //                             indicatorColor="primary"
        //                             textColor="primary"
        //                             onChange={handleChange}
        //                             aria-label="disabled tabs example"
        //                         >
        //                             <Tab
        //                                 fullWidth
        //                                 label="Email"
        //                                 onClick={() => setType("email")}
        //                             />
        //                             <Tab
        //                                 fullWidth
        //                                 label="Phone"
        //                                 onClick={() => setType("phone")}
        //                             />
        //                         </Tabs>
        //                     </Paper>
        //                     {!IsNullOrEmpty(usererrMsg) ? (
        //                         <Box textAlign="center" className="mt-4">
        //                             <Alert severity="error">{usererrMsg}</Alert>
        //                         </Box>
        //                     ) : (
        //                         <></>
        //                     )}
        //                     {!IsNullOrEmpty(pswerrMsg) ? (
        //                         <Box textAlign="center" className="mt-4">
        //                             <Alert severity="error">{pswerrMsg}</Alert>
        //                         </Box>
        //                     ) : (
        //                         <></>
        //                     )}
        //                     <Grid
        //                         container
        //                         spacing={2}
        //                         maxWidth={false}
        //                         className="mt-4"
        //                     >
        //                         <Grid item sm={12} xs={12}>
        //                             {type === "email" ? (
        //                                 <TextField
        //                                     variant="outlined"
        //                                     fullWidth
        //                                     helperText={
        //                                         formSubmitted &&
        //                                         (IsNullOrEmpty(email) ||
        //                                             !validEmail(email))
        //                                             ? "Email Should be valid and not empty"
        //                                             : ""
        //                                     }
        //                                     error={
        //                                         formSubmitted &&
        //                                         (IsNullOrEmpty(email) ||
        //                                             !validEmail(email))
        //                                     }
        //                                     label="Email"
        //                                     placeholder="Email"
        //                                     value={email}
        //                                     onChange={(e) => {
        //                                         setEmail(e.target.value);
        //                                     }}
        //                                 />
        //                             ) : (
        //                                 <TextField
        //                                     variant="outlined"
        //                                     InputProps={{
        //                                         startAdornment: (
        //                                             <InputAdornment position="start">
        //                                                 <ReactFlagsSelect
        //                                                     className="react-select"
        //                                                     selected={selected}
        //                                                     onSelect={(code) =>
        //                                                         handleSelect(
        //                                                             code
        //                                                         )
        //                                                     }
        //                                                     countries={[
        //                                                         "MY",
        //                                                         "SG",
        //                                                         "US",
        //                                                     ]}
        //                                                     customLabels={{
        //                                                         MY: "Malaysia +60",
        //                                                         SG: "Singapore +65",
        //                                                         US: "United States +1",
        //                                                     }}
        //                                                 />
        //                                             </InputAdornment>
        //                                         ),
        //                                     }}
        //                                     fullWidth
        //                                     helperText={
        //                                         formSubmitted &&
        //                                         (IsNullOrEmpty(phone) ||
        //                                             !validPhone(phone))
        //                                             ? "Phone Should be valid and not empty"
        //                                             : ""
        //                                     }
        //                                     error={
        //                                         formSubmitted &&
        //                                         (IsNullOrEmpty(phone) ||
        //                                             !validPhone(phone))
        //                                     }
        //                                     label="Mobile number"
        //                                     placeholder="Mobile number"
        //                                     value={phone}
        //                                     onChange={(e) => {
        //                                         setPhone(e.target.value);
        //                                     }}
        //                                 />
        //                             )}
        //                         </Grid>

        //                         <Grid item sm={12} xs={12}>
        //                             <TextField
        //                                 variant="outlined"
        //                                 fullWidth
        //                                 helperText={
        //                                     formSubmitted &&
        //                                     IsNullOrEmpty(userName)
        //                                         ? "Username Should be valid and not empty"
        //                                         : ""
        //                                 }
        //                                 error={
        //                                     formSubmitted &&
        //                                     IsNullOrEmpty(userName)
        //                                 }
        //                                 label="Username"
        //                                 placeholder="Username"
        //                                 value={userName}
        //                                 onChange={(e) => {
        //                                     setUserName(e.target.value);
        //                                 }}
        //                             />
        //                         </Grid>
        //                         <Grid item sm={12} xs={12}>
        //                             <TextField
        //                                 variant="outlined"
        //                                 type={visible ? "text" : "password"}
        //                                 fullWidth
        //                                 label="Password"
        //                                 placeholder="Password"
        //                                 helperText={
        //                                     formSubmitted &&
        //                                     IsNullOrEmpty(password)
        //                                         ? "Password Should be valid and not empty"
        //                                         : ""
        //                                 }
        //                                 error={
        //                                     formSubmitted &&
        //                                     IsNullOrEmpty(password)
        //                                 }
        //                                 value={password}
        //                                 onChange={(e) => {
        //                                     setPassword(e.target.value);
        //                                 }}
        //                                 InputProps={{
        //                                     endAdornment: (
        //                                         <InputAdornment position="end">
        //                                             {visible ? (
        //                                                 <Visibility
        //                                                     onClick={() =>
        //                                                         setVisible(
        //                                                             !visible
        //                                                         )
        //                                                     }
        //                                                 />
        //                                             ) : (
        //                                                 <VisibilityOff
        //                                                     onClick={() =>
        //                                                         setVisible(
        //                                                             !visible
        //                                                         )
        //                                                     }
        //                                                 />
        //                                             )}
        //                                         </InputAdornment>
        //                                     ),
        //                                 }}
        //                             />
        //                         </Grid>
        //                         <Grid item sm={12} xs={12}>
        //                             <Button
        //                                 color="secondary"
        //                                 disabled
        //                                 className="my-2"
        //                                 fullWidth
        //                                 variant="contained"
        //                                 onClick={() => handleSignUp()}
        //                             >
        //                                 {isLoading ? (
        //                                     <span
        //                                         className="spinner-border spinner-border-sm"
        //                                         role="status"
        //                                         aria-hidden="true"
        //                                     />
        //                                 ) : (
        //                                     "Sign up"
        //                                 )}
        //                             </Button>
        //                         </Grid>
        //                     </Grid>
        //                     <p className="formText my-1 cursor">
        //                         Already have an account?{" "}
        //                         <Link className="cursor" to="/login">
        //                             Sign in
        //                         </Link>
        //                     </p>
        //                     <div className="socialButtons">
        //                         <LoginHooks />
        //                         <Button
        //                             fullWidth
        //                             className="mt-2"
        //                             color="primary"
        //                             variant="outlined"
        //                             startIcon={
        //                                 <img
        //                                     src={`${process.env.PUBLIC_URL}/img/tiktok-icon.svg`}
        //                                     alt=""
        //                                 />
        //                             }
        //                         >
        //                             Sign up with Tiktok
        //                         </Button>
        //                     </div>
        //                 </div>
        //                 <div className="col-lg-1"></div>
        //                 <div className="col-lg-6 text-start text-lg-end pe-3 pe-lg-5 mt-4 mt-lg-0">
        //                     <Hidden implementation="js" only={["xs", "sm"]}>
        //                         <img
        //                             src={`${process.env.PUBLIC_URL}/img/sign-up-img.png`}
        //                             alt=""
        //                         />
        //                     </Hidden>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        //     <MainFooter />
        // </>
    );
}

export default SignUp;
